/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_weekdays_tuesday = /** @type {(inputs: {}) => string} */ () => {
	return `Úterý`
};

const da_weekdays_tuesday = /** @type {(inputs: {}) => string} */ () => {
	return `Tirsdag`
};

const de_weekdays_tuesday = /** @type {(inputs: {}) => string} */ () => {
	return `Dienstag`
};

const en_weekdays_tuesday = /** @type {(inputs: {}) => string} */ () => {
	return `Tuesday`
};

const es_weekdays_tuesday = /** @type {(inputs: {}) => string} */ () => {
	return `Martes`
};

const fr_weekdays_tuesday = /** @type {(inputs: {}) => string} */ () => {
	return `Mardi`
};

const hu_weekdays_tuesday = /** @type {(inputs: {}) => string} */ () => {
	return `Kedd`
};

const it_weekdays_tuesday = /** @type {(inputs: {}) => string} */ () => {
	return `Martedì`
};

const nl_weekdays_tuesday = /** @type {(inputs: {}) => string} */ () => {
	return `Dinsdag`
};

const pl_weekdays_tuesday = /** @type {(inputs: {}) => string} */ () => {
	return `Wtorek`
};

const pt_weekdays_tuesday = /** @type {(inputs: {}) => string} */ () => {
	return `Terça-feira`
};

const sv_weekdays_tuesday = /** @type {(inputs: {}) => string} */ () => {
	return `Tisdag`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const weekdays_tuesday = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.weekdays_tuesday(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("weekdays_tuesday", locale)
	if (locale === "cs") return cs_weekdays_tuesday(inputs)
	if (locale === "da") return da_weekdays_tuesday(inputs)
	if (locale === "de") return de_weekdays_tuesday(inputs)
	if (locale === "en") return en_weekdays_tuesday(inputs)
	if (locale === "es") return es_weekdays_tuesday(inputs)
	if (locale === "fr") return fr_weekdays_tuesday(inputs)
	if (locale === "hu") return hu_weekdays_tuesday(inputs)
	if (locale === "it") return it_weekdays_tuesday(inputs)
	if (locale === "nl") return nl_weekdays_tuesday(inputs)
	if (locale === "pl") return pl_weekdays_tuesday(inputs)
	if (locale === "pt") return pt_weekdays_tuesday(inputs)
	return sv_weekdays_tuesday(inputs)
};
export { weekdays_tuesday as "weekdays.tuesday" }